import React, { useState } from 'react';
import type { FC } from 'react';
import { Box, Text, Link, useInput, Key } from '@wix/cli-ui-kit';
import { Trans } from '@wix/cli-i18n';
import { openBrowser } from '@wix/user-browser';
import { ErrorViewer, useErrorReporter } from '@wix/cli-error-reporting';
import { useColoredVerificationUri } from '../useColoredVerificationUri.js';

interface Props {
  userCode: string;
  verificationUri: string;
}

export const LoginInstructions: FC<Props> = ({ userCode, verificationUri }) => {
  const { coloredVerificationUri, signupUri } =
    useColoredVerificationUri(verificationUri);
  const { reportError } = useErrorReporter();
  const [openBrowserError, setOpenBrowserError] = useState<unknown>(null);

  useInput((input, key) => {
    if (key.return) {
      openBrowser(coloredVerificationUri).catch((error: unknown) => {
        reportError(error);
        setOpenBrowserError(error);
      });
    }
    if (input === ' ') {
      openBrowser(signupUri).catch((error: unknown) => {
        reportError(error);
        setOpenBrowserError(error);
      });
    }
  });

  return (
    <>
      <Trans i18nKey="login.instructions_title" />
      <Box flexDirection="column" marginTop={1} marginBottom={1} marginLeft={2}>
        <Box marginBottom={1}>
          <Trans
            i18nKey="login.instructions_details"
            components={[<Text skin="info" />]}
            values={{ code: userCode }}
          />
        </Box>
        <Box marginBottom={1}>
          <Trans
            i18nKey="login.have_wix_account"
            components={[
              <Key value="enter" />,
              <Link url={coloredVerificationUri} />,
            ]}
          />
        </Box>
        <Trans
          i18nKey="login.new_to_wix"
          components={[<Key value="space" />, <Link url={signupUri} />]}
        />
      </Box>

      {openBrowserError != null && (
        <>
          <Box flexDirection="column" marginBottom={1}>
            <ErrorViewer error={openBrowserError} />
          </Box>

          <Trans
            i18nKey="login.error_opening_browser"
            components={[<Link url={coloredVerificationUri} />]}
          />
        </>
      )}
    </>
  );
};
